import { render, staticRenderFns } from "./BigDataSelect.vue?vue&type=template&id=761cf344&scoped=true"
import script from "./BigDataSelect.vue?vue&type=script&lang=js"
export * from "./BigDataSelect.vue?vue&type=script&lang=js"
import style0 from "./BigDataSelect.vue?vue&type=style&index=0&id=761cf344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761cf344",
  null
  
)

export default component.exports